// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tx-total-label[data-v-274bfbb5] {\n  font-weight: 400;\n}\n", ""]);
// Exports
module.exports = exports;
